import countryToCurrency from "country-to-currency";

/**
 * Default ISO 4217 currency for an ISO 3166-1 alpha-2 country code.
 * Used when creating accounts so general settings can be seeded by country.
 */
export function getDefaultCurrencyForCountry(iso3166Alpha2) {
  if (!iso3166Alpha2 || typeof iso3166Alpha2 !== "string") {
    return "USD";
  }
  const code = iso3166Alpha2.trim().toUpperCase();
  return countryToCurrency[code] || "USD";
}
